import { useEffect, useRef, useState } from "react";
import { fieldType } from "../../../../types/form";
import Datepicker from "react-tailwindcss-datepicker";

type Props = {
  dataField: fieldType;
  onChange: (data: any) => void;
  value: any;
  errors?: any;
  type: string;
  setValue?: any;
};

function DateField(props: Props) {
  const { dataField, onChange, value, errors, setValue } = props;
  const inputRef = useRef<HTMLDivElement | null>(null);
  const [popoverDirection, setPopoverDirection] = useState<"up" | "down">("down");

  useEffect(() => {
    if (dataField.default) {
      setValue(dataField.key, dataField.default);
    }
  }, [dataField]);

  useEffect(() => {
    const updateDirection = () => {
      const rect = inputRef.current?.getBoundingClientRect();
      if (!rect) return;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      // Heuristic: if снизу меньше места, чем сверху, открываем вверх
      setPopoverDirection(spaceBelow < spaceAbove ? "up" : "down");
    };
    updateDirection();
    window.addEventListener("resize", updateDirection);
    window.addEventListener("scroll", updateDirection, true);
    return () => {
      window.removeEventListener("resize", updateDirection);
      window.removeEventListener("scroll", updateDirection, true);
    };
  }, []);

  return (
    <div className={`${dataField.width} mb-5`}>
      <label className="flex flex-row gap-1 text-sm font-medium leading-6 text-gray-900">
        <span>{dataField.title}</span>
        {dataField.require && (
          <div className="flex flex-row gap-1">
            <span className="text-[#BA0C2F]">*</span>
            {Object.keys(errors).length > 0 && errors[dataField.key] && (
              <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
            )}
          </div>
        )}
      </label>
      <div className="mt-2">
        <Datepicker
          containerClassName={(defaultClassName) => `${defaultClassName} tg-datepicker-center-mobile`}
          inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
          useRange={false}
          toggleClassName="absolute right-[20px] top-0 h-full px-3 text-gray-400 focus:outline-none disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]"
          asSingle={true}
          i18n="ru"
          popoverDirection="down"
          startWeekOn={"mon"}
          primaryColor="blue"
          disabled={dataField.disabled}
          displayFormat="DD.MM.YYYY"
          popoverDirection={popoverDirection}
          readOnly={true}
          minDate={dataField.minDate}
          maxDate={dataField.maxDate}
          value={value || dataField.default || { startDate: null, endDate: null }}
          onChange={onChange}
          placeholder={dataField.placeholder}
        />
      </div>
      {dataField.notice && <div className="text-sm text-[#6B7280]">{dataField.notice}</div>}
    </div>
  );
}

export default DateField;
